import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_AdvisorSession, ModuleFE_AdvisorWindowMessenger, ModuleFE_EMInterface, modulesToAwait_AdvisorConfig, QuaiAdvisorPageLoader } from '@app/advisor-frontend';
import { AwaitModules, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { Outlet } from 'react-router';
import { ModuleFE_AdvisorAnalytics } from '../../_analytics/consts.js';
import { ModuleFE_AdvisorSync } from '../../modules/ModuleFE_AdvisorSync/ModuleFE_AdvisorSync.js';
import { ModuleFE_AdvisorABTesting } from '../../modules/ModuleFE_AdvisorSettings/ModuleFE_AdvisorABTesting.js';
const trackedEvents = ['uiLoad_hpi',
    'uiLoad_findings',
    'uiLoad_inbox',
    'uiLoad_protocols',
    'uiLoad_liveMdm',
    'uiLoad_OrderCart',
    'uiLoad_keyScores'];
export class ComponentValidateSessionV2 extends ComponentSync {
    launchAnalyticsReported = false;
    //######################### Life Cycle #########################
    __onLoadingInitialData() {
        // @ts-ignore
        this.state.loadingInitialData = ModuleFE_EMInterface.isLoadingInitialData();
        this.forceUpdate();
    }
    __onAdvisorAnalyticsEventSent = (eventKey) => {
        //Trigger "app-launch" event and lexicon update if all ui load events are done
        if (this.launchAnalyticsReported || !ModuleFE_AdvisorAnalytics.eventsHaveTriggered(trackedEvents))
            return;
        this.launchAnalyticsReported = true;
        //Report "app-launch"
        ModuleFE_AdvisorAnalytics.updateLexicon();
        ModuleFE_AdvisorAnalytics.updateUser();
        const lastSeenAt = ModuleFE_AdvisorSession.lastSeenAt;
        const windowOriginTime = window.performance.timeOrigin;
        ModuleFE_AdvisorAnalytics.trigger.general.app_launch({
            lastSeen: lastSeenAt?.previous,
            timeToReady_ms: Date.now() - windowOriginTime,
        });
        //If the window is focused, report practitioner view
        if (document.hasFocus())
            ModuleFE_EMInterface.recordPractitionerView();
    };
    deriveStateFromProps(nextProps, state) {
        state.loadingInitialData ??= false;
        return state;
    }
    async componentDidMount() {
        if (!ModuleFE_AdvisorSession.hasSessionData())
            return;
        this.attachFocusListener();
        const windowTimeOrigin = window.performance.timeOrigin;
        const clientTimeOrigin = ModuleFE_AdvisorWindowMessenger.launchTimeStamp;
        let parentWindowTimeOrigin;
        try {
            parentWindowTimeOrigin = window.parent.performance.timeOrigin;
        }
        catch (e) {
            this.logWarning('Could not get parent time origin', e);
        }
        try {
            const advisorConfig = ModuleFE_AdvisorSession.getAdvisorConfig();
            ModuleFE_AdvisorABTesting.setDefaultValues(advisorConfig.abTesting);
            ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_start({
                windowTimeOrigin,
                clientTimeOrigin,
                parentWindowTimeOrigin,
            });
            ModuleFE_EMInterface.startFirebaseListeners();
            // await ModuleFE_EMInterface.syncSnapShot();
            await ModuleFE_AdvisorSync.syncSnapshot();
        }
        catch (err) {
            this.setState({ error: err });
        }
    }
    //######################### Logic #########################
    attachFocusListener = () => {
        window.addEventListener('focus', () => {
            //Exit if ui loading hasn't finished yet
            if (!ModuleFE_AdvisorAnalytics.eventsHaveTriggered(trackedEvents))
                return;
            ModuleFE_EMInterface.recordPractitionerView();
        });
    };
    //######################### Render #########################
    render() {
        if (!ModuleFE_AdvisorSession.hasSessionData())
            return _jsx("div", { className: 'no-session-message', children: "No Session ID found. Make sure you launch the Advisor using Smart on FHIR..." });
        if (this.state.error) {
            return _jsxs(LL_V_L, { className: 'ts-error-boundary__error', children: [_jsx("div", { className: 'ts-error-boundary__error-title', children: "Error Message" }), _jsx("div", { className: 'ts-error-boundary__error-message', children: this.state.error.toString() })] });
        }
        return _jsx(AwaitModules, { modules: modulesToAwait_AdvisorConfig, customLoader: _jsx(QuaiAdvisorPageLoader, { text: 'Loading Configuration...' }), children: _jsx(Outlet, {}) });
    }
}
//# sourceMappingURL=ComponentValidateSessionV2.js.map